exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul li{padding-left:.3em;padding-right:.3em}li a{display:block}#collapse-menu{padding-right:1em}#header{width:100%;box-sizing:content-box;height:20px;background-color:#e3f2fd;opacity:.95;filter:(opacity=50)}.bar-style{max-height:inherit}.bar-container{padding-right:1em;max-height:40px}#bname{font-size:2rem;margin-right:2.1rem;width:10%}.logo{float:left;max-height:25px;width:auto}body{line-height:1.5}@media screen and (device-width:375px){body .nav-item{font-size:2rem}#header .navbar-brand,body h2{font-size:3rem}}@media screen and (device-width:412px){body .nav-item{font-size:2rem}#header .navbar-brand,body h2{font-size:3rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5f380dfb","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 339
// module chunks = 0